"use client";

import { AboutStoryBackground } from "@/components/home/about-story/AboutStoryBackground";
import { AboutStoryContent } from "@/components/home/about-story/AboutStoryContent";
import { AboutStoryImage } from "@/components/home/about-story/AboutStoryImage";
import type { HomeAboutStoryContent } from "@/lib/api-types";

type HomeAboutStorySectionProps = {
  aboutStory: HomeAboutStoryContent;
};

export function HomeAboutStorySection({ aboutStory }: HomeAboutStorySectionProps) {
  return (
    <section
      id="about"
      className="home-charity-section relative overflow-hidden bg-[var(--charity-ivory)] py-16 md:py-24"
    >
      <AboutStoryBackground />

      <div className="relative mx-auto grid max-w-7xl gap-12 px-4 md:grid-cols-2 md:items-center md:gap-16 md:px-6 lg:gap-20">
        <AboutStoryImage
          src={aboutStory.missionImage}
          alt={aboutStory.missionImageAlt}
        />
        <AboutStoryContent aboutStory={aboutStory} />
      </div>
    </section>
  );
}
